import { render, staticRenderFns } from "./Sustainability-Label-List.vue?vue&type=template&id=367d3d90&scoped=true&lang=pug"
import script from "./Sustainability-Label-List.vue?vue&type=script&lang=js"
export * from "./Sustainability-Label-List.vue?vue&type=script&lang=js"
import style0 from "./Sustainability-Label-List.vue?vue&type=style&index=0&id=367d3d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d3d90",
  null
  
)

export default component.exports